import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import EmployeeForm from './components/employeeForm';
import { createEmployee, navigate, clearValidationErrors } from 'actionCreators';
import { getEmployeeErrors, getWorkroomList } from '../../../../reducers';
import ui from 'redux-ui';

class EmployeeNew extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = () => { this.props.dispatch(navigate('/employees')); };
    this.setSucessMessage = (name, email) => {
      const msg = `${name} was added. A confirmation email was sent to ${email}.
      This email will expire in 7 days.`;
      this.props.updateUI('successMessage', msg);
    };
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(clearValidationErrors('EMPLOYEE'));
  }

  handleSave(employee) {
    const { dispatch } = this.props;
    dispatch(createEmployee(employee, this.setSucessMessage));
  }

  render() {
    const { errors, workrooms, user } = this.props;
    return (
      <EmployeeForm
        errors={errors}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        workrooms={workrooms}
        user={user}
      />
    );
  }
}

EmployeeNew.propTypes = {
  dispatch: PropTypes.func,
  updateUI: PropTypes.func,
  errors: PropTypes.object,
  workrooms: PropTypes.array,
  user: PropTypes.object,
};

const mapStateToProps = state => (
  {
    errors: getEmployeeErrors(state) || {},
    workrooms: getWorkroomList(state),
    user: state.user,
  }
);

export default ui()(connect(
  mapStateToProps,
)(EmployeeNew));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/employees/employeeNew.jsx